const semanticClassNames = {
  root: 'svg-image',
} as const;

export default semanticClassNames;
